var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.options && _vm.series && _vm.series[0].data.length)?_c('apexchart',{ref:"chart",attrs:{"type":"line","width":"600px","max-height":"800px","options":_vm.options,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }